module.exports = __webpack_public_path__ + "static/media/AutofacIcon.78fb14aa.svg";